
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.6822 13.0002C18.2208 12.0169 18.5017 10.9196 18.5 9.80559C18.5 6.0469 15.3661 3 11.5 3C7.63395 3 4.50001 6.0469 4.50001 9.80559C4.49718 11.411 5.08088 12.9652 6.14707 14.1912L6.1553 14.2012C6.15818 14.2036 6.16066 14.2068 6.16271 14.2092H6.14707L10.3009 18.4967C10.4549 18.6556 10.6407 18.7823 10.8469 18.8688C11.053 18.9554 11.2752 19 11.4998 19C11.7244 19 11.9465 18.9554 12.1527 18.8688C12.3589 18.7823 12.5447 18.6556 12.6986 18.4967L16.8529 14.2092H16.8373L16.8439 14.2016L16.8447 14.2008C16.8743 14.1664 16.904 14.1319 16.9332 14.0967C17.2188 13.7554 17.4698 13.3881 17.6826 12.9998L17.6822 13.0002ZM11.5016 12.4077C10.8464 12.4077 10.218 12.1547 9.75468 11.7042C9.29136 11.2537 9.03106 10.6428 9.03106 10.0058C9.03106 9.36871 9.29136 8.75776 9.75468 8.3073C10.218 7.85684 10.8464 7.60378 11.5016 7.60378C12.1569 7.60378 12.7853 7.85684 13.2486 8.3073C13.7119 8.75776 13.9722 9.36871 13.9722 10.0058C13.9722 10.6428 13.7119 11.2537 13.2486 11.7042C12.7853 12.1547 12.1569 12.4077 11.5016 12.4077Z"}})])
          )
        }
      }
    